var _circle, _path, _circle2, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCryptoCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 28,
    r: 16,
    fill: "#5AA58C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.774 26.232v-2.173h4.925V20.8h-13.4v3.26h4.926v2.173c-3.984.217-7.026 1.014-7.026 1.956 0 .941 3.042 1.738 7.026 1.955v6.88h3.549v-6.88c3.983-.217 7.025-.942 7.025-1.956s-3.042-1.738-7.025-1.955Zm0 3.26h-1.739c-.941 0-1.593 0-1.81-.073-3.55-.073-6.157-.652-6.157-1.449 0-.796 2.608-1.376 6.157-1.52v2.39c.217 0 .869.072 1.81.072 1.087 0 1.666-.073 1.739-.073v-2.317c3.549.145 6.156.796 6.156 1.52 0 .725-2.607 1.304-6.156 1.45Z",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 28,
    r: 16,
    fill: "#F90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.366 31.741c.128-.84-.096-1.568-.664-2.168-.257-.289-.585-.497-.897-.76.056-.017.096-.04.128-.049 2.025-.384 2.65-3.137 1.641-4.434a4.713 4.713 0 0 0-1.489-1.24 36.313 36.313 0 0 0-1.248-.624c.224-.777.56-1.865.808-2.73l-1.633-.472c-.264.849-.568 1.913-.808 2.665l-1.312-.384c.232-.776.552-1.817.792-2.665l-1.64-.48c-.249.864-.577 1.937-.857 2.665-1.12-.344-2.209-.656-3.314-.992-.176.6-.352 1.16-.52 1.744.232.088.44.144.657.208.208.064.416.12.624.2.552.209.76.609.6 1.177-.696 2.345-1.409 4.682-2.12 7.019-.145.512-.417.656-.93.512l-.015-.008-1.089-.32c-.312.64-.6 1.232-.912 1.857 1.12.344 2.185.664 3.305 1.008-.248.849-.568 1.913-.824 2.793l1.64.48c.273-.88.577-1.92.833-2.745.464.137.88.273 1.305.409-.24.84-.56 1.864-.809 2.713l1.64.48c.273-.88.57-1.913.817-2.713.056.016.096.008.136.024.833.096 1.641.264 2.457.296 1.073.048 2.017-.288 2.722-1.153.544-.664.856-1.456.976-2.313Zm-6.003-8.243.84.24c.721.208 1.425.464 2.01.953.536.448.688 1.024.48 1.632-.216.633-.729.993-1.44 1.009-.705.04-1.377-.112-2.05-.305-.28-.08-.552-.176-.816-.256.32-1.08.632-2.152.976-3.273Zm1.169 9.196c-1.017.144-1.985-.136-2.945-.4l-.056-.016c-.256-.072-.505-.16-.777-.24.368-1.209.729-2.401 1.097-3.602l.968.28c.928.272 1.809.576 2.537 1.193.52.424.744.992.552 1.68-.2.68-.696 1.009-1.376 1.105Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoCurrency);
export default __webpack_public_path__ + "static/media/crypto_currency.46b47aa3.svg";
export { ForwardRef as ReactComponent };